import ajax from "../../authenticationSafeAjax";

export function requestRegistrationDetails(callback) {
    ajax({
        url: "/recorder/api/user",
        method: "GET"
    }, callback);
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/actions/registrationRequests.js
 **/